export enum PriceShortCodes {
	startingPrice = '{{starting_price}}',
	asShownPrice = '{{as_shown_price}}',
}

export enum DisclosureShortCodes {
	startingPriceDisclosure = '{{starting_price_disclosure}}',
	asShownPriceDisclosure = '{{as_shown_price_disclosure}}',
}
